import { Briefcase, type LucideIcon } from "lucide-react";
import { partnerBookingStatusConfig } from "./bookingStatus";
import type { BookingListRow } from "./bookingViewModel";

export interface BookingAppearance {
  Icon: LucideIcon;
  bgColor: string;
  color: string;
}

/** Icon and colors for a booking row (matches the left icon box on booking cards). */
export function getBookingAppearance(
  booking: BookingListRow,
  sellerMode: boolean,
): BookingAppearance {
  if (sellerMode) {
    const config = partnerBookingStatusConfig(
      booking.status,
      booking.handshakeStatus,
    );
    return {
      Icon: config.icon,
      bgColor: config.bgColor,
      color: config.color,
    };
  }

  return {
    Icon: Briefcase,
    bgColor: "bg-primary-50",
    color: "text-primary-600",
  };
}
